@if (listConfig.HasSubComponent && isSubComponentVisible()) {
  <td (click)="toggleListSubContent(RowNumber)">
    @if (listConfig.CalsiumListComponent.toggleSubContent != RowNumber) {
      <i class="fas fa-caret-right"></i>
    }
    @if (listConfig.CalsiumListComponent.toggleSubContent == RowNumber) {
      <i class="fas fa-caret-down"></i>
    }
  </td>
}
@if (listConfig.HasSubComponent && !isSubComponentVisible()) {
  <td>
    &nbsp;
  </td>
}
@if (IsViewMode()) {
  @for (column of listConfig.ListColumns; track column) {
    @if (column.IsVisible | async) {
      <td [ngClass]="{'compact-message-column': isCompactMessageColumn(column)}" [class]="(column.CssClass || '') + ' ' + (column.TextAlignment || '')">
        @if (column.DataType === 'string' || column.DataType === 'number' || column.DataType === 'list' || column.DataType === 'date' ) {
          @if (isCompactMessageColumn(column)) {
            <div class="compact-message-wrapper" (click)="$event.stopPropagation()">
              <span class="compact-message-text" [title]="getDisplayValue(column)">{{getDisplayValue(column)}}</span>
              @if (getDisplayValue(column)) {
                <button type="button" class="message-info-button" [title]="getDisplayValue(column)"
                  (click)="toggleMessagePopup(column, $event)">
                  <i class="material-icons">info_outline</i>
                </button>
              }
              @if (isMessagePopupOpen(column)) {
                <div class="compact-message-popup">
                  {{getDisplayValue(column)}}
                </div>
              }
            </div>
          } @else {
            @if (column.DisplayColumnName !== '') {
              <span
              [ngClass]="{'multiline-cell': column.IsMultiLine}">{{GetValue(column.DisplayColumnName) | pipe:[column.DisplayPipe] }}</span>
            }
            @if (column.DisplayColumnName === '') {
              <span
              [ngClass]="{'multiline-cell': column.IsMultiLine}">{{GetValue(column.ColumnName) | pipe:[column.DisplayPipe] }}</span>
            }
          }
          @if (column.IsCurrency) {
            <span>SEK</span>
          }
        }
        @if (column.DataType === 'anchor') {
          @if (column.DisplayColumnName !== '') {
            <span>
              @if (IsAnchor(column)) {
                <a routerLink="{{GetAnchorLink(column)}}">{{GetValue(column.DisplayColumnName)}}</a>
              }
              @if (!IsAnchor(column)) {
                <span>{{GetValue(column.DisplayColumnName)}}</span>
              }
            </span>
          }
          @if (column.DisplayColumnName === '') {
            <span>
              @if (IsAnchor(column)) {
                <a routerLink="{{GetAnchorLink(column)}}">{{GetValue(column.ColumnName)}}</a>
              }
              @if (!IsAnchor(column)) {
                <span>{{GetValue(column.ColumnName)}}</span>
              }
            </span>
          }
        }
        @if (column.DataType === 'details' || column.DataType === 'manage') {
          @if (IsAnchor(column) || IsClickable(column)) {
            <a id="details-btn" class="btn"
              [routerLink]="GetAnchorLink(column)">
              <span (click)="OnClick($event, column)">
                @if (column.DataType === 'details') {
                  <i class="scania-icon-see-details sm"></i>
                }
                @if (column.DataType === 'manage') {
                  <i class="material-icons" style="color: var(--dark);">
                    build
                  </i>
                }
              </span>
            </a>
          }
        }
        @if (column.DataType === 'radio') {
          <mat-radio-button name="optradio" (change)="onChange(column)"></mat-radio-button>
        }
        @if (column.DataType === 'selector' && ShowCheckBox()) {
          <mat-checkbox name="optcheckbox" [(checked)]="selected" [disabled]="!isSelectorEnabled()"
          (change)="onRowSelectionChanged($event)"></mat-checkbox>
        }
        @if (column.DataType === 'boolean') {
          <div class="icon">
            @if (GetValue(column.ColumnName)) {
              <i [ngStyle]="column.BooleanTrueIconStyle"
                class="true material-icons">
                {{column.BooleanTrueIcon}}
              </i>
            } @else {
              <i class="false material-icons" [ngStyle]="column.BooleanFalseIconStyle">
                {{column.BooleanFalseIcon}}
              </i>
            }
          </div>
        }
      </td>
    }
  }
}
@if (!IsViewMode()) {
  @if (IsEditMode()) {
    @for (column of listConfig.ListColumns; track column) {
      @if (column.IsVisible | async) {
        <td>
          @if (column.AllowEdit) {
            <app-calsiumlist-cell [Column]="column" [Value]="GetValue(column.ColumnName)"
              [IsEditMode]="true" [listConfig]="listConfig" [RowNumber]="RowNumber" [Form]="Form"
            [resources]="resources"></app-calsiumlist-cell>
          }
          @if (!column.AllowEdit) {
            <div [class]="column.TextAlignment">
              @if (column.DisplayColumnName !== '') {
                <span
                >{{GetValue(column.DisplayColumnName) | pipe:[column.DisplayPipe]}}</span>
              }
              @if (column.DisplayColumnName === '') {
                <span
                >{{GetValue(column.ColumnName) | pipe:[column.DisplayPipe]}}</span>
              }
              @if (column.IsCurrency) {
                <span>SEK</span>
              }
            </div>
          }
        </td>
      }
    }
  }
  @if (IsAddMode) {
    @for (column of listConfig.ListColumns; track column) {
      <td>
        <app-calsiumlist-cell [Column]="column" [RowNumber]="RowNumber" [IsAddMode]="true" [listConfig]="listConfig"
        [Form]="Form"></app-calsiumlist-cell>
      </td>
    }
  }
}
@if (listConfig.AllowEdit || listConfig.AllowDelete || listConfig.AllowAdd || listConfig.AllowClone || listConfig.ActionsButttons.length) {
  <td
    class="menu-column">
    @for (action of listConfig.ActionsButttons; track action) {
      <button class="btn btn-default" (click)="ActionOnClick(action)">
        <i [ngClass]="action.IconCssClass" [title]="action.Title"></i>
      </button>
    }
    @if (IsAddMode) {
      <button class="btn btn-default" (click)="AddItem()">
        <i class="fas fa-save black" title="Save"></i>
      </button>
    }
    @if (listConfig.AllowClone && IsViewMode()) {
      <button class="btn btn-default" (click)="CloneItem()">
        <i class="fa fa-clone black" aria-hidden="true" title="Clone"></i>
      </button>
    }
    @if (listConfig.AllowEdit && IsViewMode() && isEditVisible()) {
      <button class="btn btn-default" (click)="editRow()"
        [disabled]="disableEditButton">
        <i class="fas fa-edit black" title="Edit"></i>
      </button>
    }
    @if (listConfig.AllowDelete && IsViewMode() && isDeleteVisible()) {
      <button class="btn btn-default"
        (click)="DeleteRow()">
        <i class="fas fa-trash-alt black" title="Delete"></i>
      </button>
    }
    @if (listConfig.AllowEdit && IsEditMode()) {
      <button class="btn btn-default" (click)="saveEditedRow()">
        <i class="fas fa-save black" title="Save Edited"></i>
      </button>
    }
    @if ((listConfig.AllowEdit && IsEditMode()) || IsAddMode) {
      <button class="btn btn-default"
        (click)="cancelEditRow()">
        <i class="fas fa-ban black" title="Cancel"></i>
      </button>
    }
  </td>
}